module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.loadingSave),
      expression: "loadingSave",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "element-loading-text": 'Aguarde enquanto o upload é processado...' + (_vm.requestParam.uploadProgress != null ? '\n' + _vm.requestParam.uploadProgress + '%' : '')
    }
  }, [_c('UploadPagina', {
    attrs: {
      "parent": this
    }
  }), _vm._v(" "), _c('ed-modal', {
    attrs: {
      "title": "UPLOAD DE ASO",
      "modal": _vm.parent.showUploadASO,
      "loadingSave": _vm.loadingSave,
      "onSave": _vm.salvar,
      "width": "98%",
      "saveName": "Salvar"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.tagConfig),
      callback: function($$v) {
        _vm.tagConfig = $$v
      },
      expression: "tagConfig"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-cadastro"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" Fazer Novo Upload")]), _vm._v(" "), (_vm.formData.tipo == 86) ? _c('el-alert', {
    attrs: {
      "title": "Atenção",
      "type": "warning",
      "description": "Na Identificação Automática o sistema reconhece automaticamente a quem pertence o ASO. Para isso funcionar verifique se o ASO está em PDF e possui no rodapé o código de identificação.",
      "show-icon": ""
    }
  }) : (_vm.formData.tipo == 87) ? _c('el-alert', {
    attrs: {
      "title": "Atenção",
      "type": "warning",
      "description": "Na Identificação Manual o sistema exige que você informe a quem pertence o ASO: empresa, funcionário e a consulta.",
      "show-icon": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    attrs: {
      "label-position": "top",
      "label-width": "100px",
      "model": _vm.formData
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Escolha o Tipo do Upload",
      "prop": "tipo",
      "rules": [{
        required: true,
        message: 'Campo Obrigatorio'
      } ]
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.formData.tipo),
      callback: function($$v) {
        _vm.$set(_vm.formData, "tipo", $$v)
      },
      expression: "formData.tipo"
    }
  }, _vm._l((_vm.lstTipoUpload), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.descricao
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('el-form-item', {
    class: _vm.error['arquivo'] ? 'is-error' : '',
    attrs: {
      "label": "Selecione o ASO (no formato PDF e no máximo 25MB de tamanho)",
      "prop": "arquivo",
      "rules": [{
        required: true,
        message: 'Campo Obrigatorio'
      } ]
    }
  }, [_c('Upload', {
    attrs: {
      "onChangeFile": _vm.handleArquivo,
      "currentFile": _vm.formData.arquivo,
      "ordem": "1"
    }
  }), _vm._v(" "), (_vm.error['arquivo']) ? _c('div', {
    staticClass: "el-form-item__error"
  }, [_vm._v(_vm._s(_vm.error['arquivo'][0]))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Escolha o Tipo do Documento",
      "prop": "documento",
      "rules": [{
        required: true,
        message: 'Campo Obrigatorio'
      } ]
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\tEscolha o Tipo do Documento\n\t\t\t\t\t\t\t\t\t\t"), (_vm.formData.documento == 83) ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Certifique-se que a primeira página do Prontuário Médico esteja anexado a FEMO da consulta ( Ficha de Exame Médico Ocupacional)",
      "placement": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e()], 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "disabled": _vm.formData.tipo == 86
    },
    model: {
      value: (_vm.formData.documento),
      callback: function($$v) {
        _vm.$set(_vm.formData, "documento", $$v)
      },
      expression: "formData.documento"
    }
  }, _vm._l((_vm.lstTipoDocumento), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.descricao
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Empresa",
      "prop": "id_emp",
      "rules": [{
        required: (_vm.formData.tipo == 87),
        message: 'Campo Obrigatorio'
      } ]
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "clearable": "",
      "placeholder": "Digite o nome da empresa",
      "remote-method": _vm.getEmpresa,
      "loading": _vm.loadingEmpresa,
      "disabled": _vm.formData.tipo == 86
    },
    on: {
      "change": _vm.getFuncionario
    },
    model: {
      value: (_vm.formData.id_emp),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id_emp", $$v)
      },
      expression: "formData.id_emp"
    }
  }, _vm._l((_vm.lstEmpresa), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.nome
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [_c('b', [_vm._v(_vm._s(item.nome))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right",
        "color": "#8492a6",
        "font-size": "13px"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(item.cnpj) + "\n\t\t\t\t\t\t\t\t\t\t")])])
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Funcionario",
      "prop": "id_fun",
      "rules": [{
        required: (_vm.formData.tipo == '87'),
        message: 'Campo Obrigatorio'
      } ]
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "clearable": "",
      "placeholder": "Digite o nome do funcionário",
      "remote-method": _vm.getFuncionario,
      "loading": _vm.loadingFuncionario,
      "disabled": !_vm.formData.id_emp
    },
    on: {
      "change": _vm.getConsulta
    },
    model: {
      value: (_vm.formData.id_fun),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id_fun", $$v)
      },
      expression: "formData.id_fun"
    }
  }, _vm._l((_vm.lstFuncionario), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.nome
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [_c('b', [_vm._v(_vm._s(item.nome))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right",
        "color": "#8492a6",
        "font-size": "13px"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(item.cnpj) + "\n\t\t\t\t\t\t\t\t\t\t")])])
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Consulta",
      "prop": "id_con",
      "rules": [{
        required: (_vm.formData.tipo == '87'),
        message: 'Campo Obrigatorio'
      } ]
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "Selecione a consulta",
      "loading": _vm.loadingConsulta,
      "disabled": !_vm.formData.id_fun
    },
    model: {
      value: (_vm.formData.id_con),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id_con", $$v)
      },
      expression: "formData.id_con"
    }
  }, _vm._l((_vm.lstConsulta), function(item) {
    return _c('el-option', {
      key: item.id_con,
      attrs: {
        "value": item.id_con,
        "label": item.id_con + ((item.dt_cad ? ' | ' + _vm.toDate(item.dt_cad, true) : '') + (item.tipo_aso ? ' | ' + item.tipo_aso.descricao : ''))
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(item.id_con) + " | " + _vm._s((item.dt_cad ? _vm.toDate(item.dt_cad, true) : '')) + " | " + _vm._s((item.tipo_aso ? item.tipo_aso.descricao : '')) + "\n\t\t\t\t\t\t\t\t\t\t")])])
  }), 1)], 1)], 1), _vm._v(" "), (_vm.formData.documento == 83) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Juntar Arquivo",
      "prop": "juntar",
      "rules": [{
        required: true,
        message: 'Campo Obrigatorio'
      } ]
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\tJuntar Arquivo\n\t\t\t\t\t\t\t\t\t\t"), (_vm.formData.documento == 83) ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Se essa opção estiver marcado, o sistema vai adicionar esse upload nos os arquivos enviados anteriormente.",
      "placement": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e()], 1), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-value": 1,
      "inactive-value": 0
    },
    model: {
      value: (_vm.formData.juntar),
      callback: function($$v) {
        _vm.$set(_vm.formData, "juntar", $$v)
      },
      expression: "formData.juntar"
    }
  })], 1)], 1) : _vm._e()])], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-historico"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    class: 'fa fa-history' + (_vm.novaLiberacao ? ' faa-flash animated' : '')
  }), _vm._v("\n\t\t\t\t\t\tHistórico de Uploads\n\t\t\t\t\t")]), _vm._v(" "), _c('TableView', {
    attrs: {
      "onSearch": _vm.getConsultaUpload,
      "onDelete": _vm.onDelete,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "loadingEditAll": _vm.loadingEditAll,
      "pagination": _vm.pagination
    }
  })], 1)], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28878304"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/consulta/liberacao/_includes/upload-aso.vue
// module id = 1440
// module chunks = 45